import type { Certainty } from "@/lib/whatif/types";

const TONE: Record<Certainty, string> = {
  FACT: "border-emerald-300/30 bg-emerald-400/10 text-emerald-200",
  PREDICTION: "border-sky-300/30 bg-sky-400/10 text-sky-200",
  THEORY: "border-violet-300/30 bg-violet-400/10 text-violet-200",
  SPECULATION: "border-amber-300/30 bg-amber-400/10 text-amber-200",
  UNKNOWN: "border-white/20 bg-white/10 text-slate-200",
};

/** Honest labelling: nothing speculative is ever presented as settled fact. */
export function CertaintyBadge({ value }: { value: Certainty }) {
  return (
    <span
      className={`inline-flex rounded-full border px-2 py-0.5 text-[10px] font-bold uppercase tracking-[0.12em] ${TONE[value]}`}
    >
      {value}
    </span>
  );
}